var Shopify = Shopify || {};
window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = function(cents, format = window.money_format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.querySelectorAll('.drop-zone__input').forEach((inputElement) => {
  const dropZoneElement = inputElement.closest('.drop-zone');

  dropZoneElement.addEventListener('click', (e) => {
    inputElement.click();
  });

  inputElement.addEventListener('change', (e) => {
    if (inputElement.files.length) {
      updateThumbnail(dropZoneElement, inputElement.files[0]);
    } else {
      dropZoneElement.classList.remove('drop-zone--added');
      dropZoneElement.querySelector('.drop-zone__thumb').remove();
      addapiveHeight();
    }
  });

  dropZoneElement.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropZoneElement.classList.add('drop-zone--over');
  });

  ['dragleave', 'dragend'].forEach((type) => {
    dropZoneElement.addEventListener(type, (e) => {
      dropZoneElement.classList.remove('drop-zone--over');
    });
  });

  dropZoneElement.addEventListener('drop', (e) => {
    e.preventDefault();

    if (e.dataTransfer.files.length) {
      inputElement.files = e.dataTransfer.files;
      updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
    } else {
      dropZoneElement.classList.remove('drop-zone--added');
      dropZoneElement.querySelector('.drop-zone__thumb').remove();
      addapiveHeight();
    }

    dropZoneElement.classList.remove('drop-zone--over');
  });
});

/**
 * Updates the thumbnail on a drop zone element.
 *
 * @param {HTMLElement} dropZoneElement
 * @param {File} file
 */
function updateThumbnail(dropZoneElement, file) {
  document.querySelector('.upload-content-wrapper .drop-zone').style.borderColor = '';

  let thumbnailElement = dropZoneElement.querySelector('.drop-zone__thumb');

  // First time - remove the prompt
  if (dropZoneElement.querySelector('.drop-zone__prompt')) {
    dropZoneElement.querySelector('.drop-zone__prompt').remove();
  }

  // First time - there is no thumbnail element, so lets create it
  if (!thumbnailElement) {
    thumbnailElement = document.createElement('div');
    thumbnailElement.classList.add('drop-zone__thumb');
    dropZoneElement.appendChild(thumbnailElement);
  }

  thumbnailElement.dataset.label = file.name;

  // Show thumbnail for image files
  if (file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
      dropZoneElement.classList.add('drop-zone--added');
      addapiveHeight();
    };
  } else {
    thumbnailElement.style.backgroundImage = null;
    dropZoneElement.classList.add('drop-zone--added');
    addapiveHeight();
  }
}

window.addEventListener(
  'dragover',
  function (e) {
    e = e || event;
    e.preventDefault();
  },
  false
);
window.addEventListener(
  'drop',
  function (e) {
    e = e || event;
    e.preventDefault();
  },
  false
);

                                    
$(document).ready(function(){
  var return_url = getParameterByName('return_url');
    if(return_url != null) {
    $('#customer_register_link').attr('href', '/account/register?return_to='+return_url);
  }

  var return_to = getParameterByName('return_to');
    if(return_to != null) {
    $('[name="return_to"]').val(return_to);
  }
// $(window).on('load', function(){
//   var sl_height = $('.slides--wrap').outerHeight();
//   $('.customize__product_wrap').css('height', sl_height);
// });
  
  // Show "Leave Site?" Dialog Box
  
  window.addEventListener("beforeunload", (event) => {
    if($('body').hasClass('product_customizer--prevent')) {
      // set a truthy value to property returnValue
      event.returnValue = true;
    }
  }, { capture: true });

    
  window.addEventListener("visibilitychange", (event) => {
    if($('body').hasClass('product_customizer--prevent')) {
      // set a truthy value to property returnValue
      event.returnValue = true;
    }
  }, { capture: true });


   
  
  if($(window).width() < 768) {
    $(".btn-for-wrap").wrapAll(`<div class="btn-main--wrapper"></div>`);
  }


  $(document).on('click', '.addtocart-trigger--js', function(){
    $('[name="add"]').click();
  });
 
  // usage step js  
  $(document).on('click','#usage-slide .inner--content-wrap', function(e){
    $('[data-step="2"]').css('pointer-events', '');
    $('#usage_var_id').val('');
    $('#usage_var_id').attr('data-price', '');
    
    var $el = $(this),
      $main_wrap = $el.closest('#usage-slide'),
      $li = $el.closest('li'),
      step_value = $li.attr('data-step-value');



      /* START:: CUSTOM AFTER EDIT.  */
        $('.step-4-global--content').hide();
        let step_value_c = step_value > 3 ? 3 : step_value == 3 ? 2 : step_value;
        $(`.step-4-global--content[data-usage-step="${step_value_c}"]`).show();
        $('#lens-type-slide').attr('data-usage', step_value_c);
      /* END:: CUSTOM AFTER EDIT.  */

    
    $('#usage-slide .usage__contents').removeClass('usage_active');
    $li.addClass('usage_active');
    
    // $('#color-slide .inner--content-wrap').removeClass('pcc_active');
    // $el.addClass('pcc_active');
    $('#usage_monogram').val($el.attr('data-title').replace('&nbsp;',''));
    $('#usage-slide').attr('data-usage-value', step_value);
    console.log(step_value,'<<<step_value');
    switch(step_value){
      case '1':
      case 1:
        $('#os_add,#od_add').prop('disabled', true);
        $('.os-add,.od-add').addClass('field-disabled');
        break;
      case '2':
      case 2:
        $('#os_add,#od_add').prop('disabled', false);
        $('.os-add,.od-add').removeClass('field-disabled');
        break;
      case '3':
      case 3:
        $('#os_add,#od_add').prop('disabled', false);
        $('.os-add,.od-add').removeClass('field-disabled');
        break;
      case '4':
      case 4:
        $('#os_add,#od_add').prop('disabled', true);
        $('.os-add,.od-add').addClass('field-disabled');
        break;
    }
    
    if($el.hasClass('goto-non-prescription')){
      if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
        stepGoTo(3);
      }
      $('[data-step="2"]').css('pointer-events', 'none');
      return;
    }
    if($el.hasClass('no-content')){
      if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
        stepGoTo(2);
      }
      return;
    }

    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
      $('.inner__subcontent_wrap').not($el.next()).slideUp(function(){
        addapiveHeight();
      });
      
      $el.next('.inner__subcontent_wrap')
      .slideToggle(function(){
        addapiveHeight();
      })
      .toggleClass('active---');
      
      $el.closest('ul').find('li').removeClass('active---');
      $el.closest('li').toggleClass('active---');
    }
  });
  $(document).on('click','#usage-slide .inner__subcontent_wrap .contents--wrapper', function(e){
    $('[data-step="2"]').css('pointer-events', '');
    var $el = $(this),
      $main_wrap = $el.closest('#usage-slide'),
      $li = $el.closest('li'),
      step_value = $li.attr('data-step-value'), 
      variant__id = null,
      $usage_var_id = $('#usage_var_id');
     $('#usage_var_id').val('');
     $('#usage_var_id').attr('data-price', '');
    
    $('#usage_monogram').val($el.find('.innertext--js').attr('data-title').replace('&nbsp;',''));

      $usage_var_id.val($el.find('[data-product-id]').val());
      $usage_var_id.attr('data-price', $el.find('[data-product-id]').attr('data-variant-price'));
    
    
    $('#usage-slide').attr('data-usage-value', step_value);
    switch(step_value){
      case '1':
        $('#os_add,#od_add').prop('disabled', true);
        $('.os_add,.od_add').addClass('field-disabled');
        break;
      case '2':
        $('#os_add,#od_add').prop('disabled', false);
        $('.os_add,.od_add').removeClass('field-disabled');
        break;
      case '3':
        $('#os_add,#od_add').prop('disabled', false);
        $('.os_add,.od_add').removeClass('field-disabled');
        break;
      case '4':
        $('#os_add,#od_add').prop('disabled', true);
        $('.os_add,.od_add').addClass('field-disabled');
        break;
    }
    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
    stepGoTo(2);
    }
  });

   
  
  //prescription prism js
  $(document).on('change','#prism', function(){
    if($(this).prop('checked')){
      $('.prism--content-wrap').slideDown(function(){
        addapiveHeight();
      });
    }else{
      $('.prism--content-wrap').slideUp(function(){
        addapiveHeight();
      });
    }
    
  });
    
  $(document).on('change','[name="is_pd"]', function(){
    if($(this).prop('checked')) {
      $("li.pd-add-one.js-pd-add-one").hide();
      $("li.pd-add-two.js-pd-add-two").show();
    }
    else{
      $("li.pd-add-one.js-pd-add-one").show();
      $("li.pd-add-two.js-pd-add-two").hide();
    }
    addapiveHeight();
  });
  
  $(document).on('click','.showmore-text', function(){
    $('.prism--header-wrap').slideToggle(function(){
      addapiveHeight();
    });
    $('.prism--header-wrap').toggleClass("active-prism");
    if($('.prism--header-wrap').hasClass("active-prism")){
      $('.showmore-text').html("Show Fewer Option");
    }else{
      $('.showmore-text').html("Show More Option");
    }
    
  });
  

  $('.slides--wrap').slick({
    slide: '.slide-item',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    arrows: false,
    adaptiveHeight: true,
    accessibility:false,
    swipe: false,
    touchMove: false
  });

  $('.slides--wrap').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var index = parseInt(currentSlide) + 1;
    var title = $('.step[data-step="'+index+'"]').attr('data-title');
    // console.log(currentSlide, nextSlide);
    $('.title--js').html(title);
    // lense_bundle_filter();
  });

  $('.slides--wrap').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    // console.log(currentSlide, nextSlide);
    lense_bundle_filter();
    createSummary();
  });


  // header steps js 
  $(document).on('click','.steps .step', function(){
    var value = $(this).attr('data-title'),
    step = $(this).attr('data-step'); 
    $('.title--js').html(value);
    $('.steps li.current-active').removeClass('current-active');
    $('.customize--content-wrap').removeClass('step-1-active step-2-active step-3-active step-4-active step-5-active');
    $('.customize--content-wrap').addClass('step-'+step+'-active');
    $(this).removeClass('step-disable');
    $(this).addClass('current-active');
    stepGoTo(step);
  });
  $('.steps .step').first().trigger('click');
  $('.steps .step').not('.current-active').addClass('preventEvents');

  $(document).on('click', '#color-slide .inner--content-wrap', function(e){
    var $el = $(this),
        $li = $el.closest('li'),
        $main_wrap = $el.closest('#color-slide'),
        step_value = $li.attr('data-step-value'),
        clr_value = '';
    $('#color-slide .inner--content-wrap').removeClass('pcc_active');
    $el.addClass('pcc_active');
    $('#color_type_monogram').attr('data-inner-value', '');
    $('#color_type_monogram').attr('data-inner-2-value', '');
    switch(step_value) {
      case '1':
      case 1:
        clr_value = 'Clear Lenses';
        break;
      case '2':
      case 2:
        clr_value = 'Blue Light Filtering';
        break;
      case '3':
      case 3:
        clr_value = 'Sunglasses';
        break;
      case '4':
      case 4:
        clr_value = 'Darkening Lenses';
        break;
    }
    $('#color_type_monogram').val(clr_value);
    $('#color-slide').attr('data-color_type-value', step_value);
    if($el.hasClass('clr-type--acc')) {
      
    } else {
      if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
        $('.acc--content--js').slideUp();
        $('.clr-type--acc').removeClass('acc-active');
       stepGoTo(4);
      }
    }
  });

  
  $(document).on('click', '#color-slide .btn-confirm', function(e){
    var $el = $(this),
        $wrap = $el.closest('.color-section'),
        $swatch__input = $wrap.find('.tint_color--js .color-swatch--input:checked'),
        $strength__input = $wrap.find('.tint_strength--js .strength_input:checked'),
        $li = $el.closest('.lense_clr_type_li'),
        li_step = $li.attr('data-step-value');
    $('#color-slide').attr('data-color_type-value', li_step);
    // $('#color_type_monogram').attr('data-inner-value', '');
     $('#color_type_monogram').attr('data-inner-value', $el.closest('[sun-step]').find('.acc-inner-js').html().split('-')[0].trim() || '');
    if($swatch__input.length) {
      $('#color_type_value_variant').val($swatch__input.val()).attr('data-price', $swatch__input.attr('data-variant-price'));
      s_clr = $swatch__input.attr('data-label');
      s_strength = $strength__input.val();
      if(s_clr == 'Default Title') {
        $('#color_type_value_monogram').val(``);
      } else {
        if($strength__input.length) {
          $('#color_type_value_monogram').val(`Tint Color: ${s_clr}, Tint Strength: ${s_strength.replace(':', ' ')}`);
        } else {
          $('#color_type_value_monogram').val(`Tint Color: ${s_clr}`);
        }
      }
    } else {
      alertPopup(`Please select a color.`);
      return false;
    }
    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
     stepGoTo(4);
    }
  });


  /* START:: CUSTOM AFTER EDIT.  */ 
  $(document).on('click', '#lens-type-slide .bundle-step--js', function(e){
    var $el = $(this),
        $variant = $el.find('[data-product-id]'),
        var_id= $variant.val(),
        var_price = $variant.attr('data-variant-price'),
        var_label = $variant.attr('data-label'),
        title = $el.attr('data-title');
    $('#lens-type-slide .bundle-step--js').removeClass('bundle__active');
    $el.addClass('bundle__active');
    $('#lenses_bundle__var_id').val(var_id).attr('data-price', var_price).attr('data-label', var_label);
    $('#lenses_bundle__monogram').val(title);

    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
      stepGoTo(4);
    }

    console.log({var_id,var_price,var_label,title}, "<<<<lens-type-slide");
  });
   /* END:: CUSTOM AFTER EDIT.  */
  
  $(document).on('click', '#lensebundle-slide .bundle-step--js', function(e){
    var $el = $(this),
        $variant = $el.find('[data-product-id]'),
        var_id= $variant.val(),
        var_price = $variant.attr('data-variant-price'),
        var_label = $variant.attr('data-label'),
        title = $el.attr('data-title');
    $('#lensebundle-slide .bundle-step--js').removeClass('bundle__active');
    $el.addClass('bundle__active');
    console.log(e.target)
    $('#lenses_bundle__var_id').val(var_id).attr('data-price', var_price).attr('data-label', var_label);
    $('#lenses_bundle__monogram').val(title);
    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
      stepGoTo(5);
    }
  });

  $(document).on('click', '.tooltip_icon__wrap', function(){
    var mgs = $(this).attr('data-content'),
      cotent_html = $(this).next('.tooltip__content_wrap');
    if(cotent_html.length){var mgs_in =cotent_html.html();mgs = `<div class="modal_tooltip__content_wrap">${mgs_in}</div>`; }
    console.log(cotent_html.length, mgs);
    alertPopup(mgs, `hide`);
  });

  $(document).on('click', '.clr-type--acc', function(){
    var $el = $(this),
        $next = $el.next(),
        $wrap = $el.closest('#color-slide'),
        $li_wrap = $el.closest('.lense_clr_type_li'),
        usage_id = $('#usage-slide').attr('data-usage-value');
    if(usage_id == 3){
      usage_id = 1;
    } else if(usage_id == 4) {
      usage_id = 3;
    }
    if($li_wrap.hasClass('has_main_default')) {
      var $elll = $li_wrap.find('.acc-inner-js').next('.acc-content-js').find('.color-section[data-usage-id="'+usage_id+'"]');
      console.log($elll, $elll.find('.btn-confirm'))
      $elll.find('.btn-confirm').trigger('click');
      return false;
    }
    $wrap.find('.acc--content--js').not($el.next()).slideUp(function(){
      //addapiveHeight();
    });
    $wrap.find('.clr-type--acc').not($el).removeClass('acc-active');
    $next.slideToggle(function(){
      addapiveHeight();
    });
    $el.toggleClass ('acc-active')
  });

  $(document).on('click', '.acc-inner-js', function(e){
    var $el = $(this),
        $next = $el.next(),
        $wrap = $el.closest('.jss-content-up'),
        $li = $el.closest('.lense_clr_type_li'),
        step = $li.attr('data-step-value'); 
    var sun_step = $el.closest('[sun-step]').attr('sun-step');
     if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){return false}
    console.log('sun_step', sun_step); 
    $('#color-slide').attr('data-inner-step', sun_step);
    $('#color_type_monogram').attr('data-inner-value', $el.html().split('-')[0].trim());

    usage_id = $('#usage-slide').attr('data-usage-value');
    if(usage_id == 3){
      usage_id = 1;
    } else if(usage_id == 4) {
      usage_id = 3;
    }

    console.log($(this).next('.acc-content-js'), '+++++++++++++++++++',$(this).next('.acc-content-js').find('.color-section[data-usage-id="'+usage_id+'"]').length, $(this).next('.acc-content-js').find('.color-section[data-usage-id="'+usage_id+'"]').hasClass('has_only_default_variant'),'<<<<<<<' );
    if($(this).next('.acc-content-js').find('.color-section[data-usage-id="'+usage_id+'"]').hasClass('has_only_default_variant')){
      var $elll = $(this).next('.acc-content-js').find('.color-section[data-usage-id="'+usage_id+'"]');
      $elll.find('.btn-confirm').trigger('click');
      return false;
    }
    
    $wrap.find('.acc-content-js').not($el.next()).slideUp(function(){
      //addapiveHeight();
    });
    $wrap.find('.acc-inner-js').not($el).removeClass('acc-in-active');
    $next.slideToggle(function(){
      addapiveHeight();
    });
    $el.toggleClass ('acc-in-active');
    if(step === '4' || step == 4) {
      setTimeout(function(){
        var scrollBottom = $(window).scrollTop() + $(window).height();
        $(window).scrollTop(scrollBottom);
      },52);
    }
  });

  $(document).on('click', '.acc-inner-2-js', function(){
    var $el = $(this),
        $next = $el.next(),
        $wrap = $el.closest('.jss-content-in');
    var sun_in_step = $el.closest('[sun-inner-step]').attr('sun-inner-step');
    console.log('sun_in_step', sun_in_step);
    $('#color-slide').attr('data-inner-2-step', sun_in_step);
    $('#color_type_monogram').attr('data-inner-2-value', '');
    $('#color_type_monogram').attr('data-inner-2-value', $el.html().split('-')[0].trim());
    $wrap.find('.acc-content-js').not($el.next()).slideUp(function(){
      //addapiveHeight();
    });
    $wrap.find('.acc-inner-2-js').not($el).removeClass('acc-in-2-active');
    $next.slideToggle(function(){
      addapiveHeight();
    });
    $el.toggleClass ('acc-in-2-active');

  });

  $(document).on('input', '#os_axis, #od_axis', function(e){
    var $el = $(this),
      val = parseFloat($el.val());
    if(val >= 0 && val <= 180) {
      
    } else {
      if(val < 0) {
        $el.val(0);
      } else if(val > 180) {
        $el.val(180);
      }
    }
  });

  $(document).on('click', '.acc--js:not(.no-content)', function(){
    var $el = $(this),
        $next = $el.next(),
        $wrap = $el.closest('.prescription_option');

    $('#presc-slide .prescription_option').removeClass('prescription_active');
    $wrap.addClass('prescription_active');
    var optionPrescriptionTitle = '';
    if($wrap.length) {
      optionPrescriptionTitle = $wrap.attr('data-option-title');
      $('#presc-slide').attr('data-prescription-method', optionPrescriptionTitle);
    }
    $('.acc-content--js').not($next).slideUp();
    $next.slideToggle(function(){
      addapiveHeight();
      if(optionPrescriptionTitle == 'enterManually') {
        var s_top = $('[data-option-title="enterManually"]').offset().top;
        console.log(s_top);
        $('body,html').animate({ scrollTop: s_top }, 800);
      }
    });
    $el.toggleClass ('acc-active');
    
  });
  

  $(document).on('click', '.nav-control--js', function(){
    var $el = $(this),
        action = $el.attr('data-action'),
        $wrap = $el.closest('.customize__lens_wrapper'),
        current_slide_step = $wrap.find('.step.step-back-current').attr('data-step') || $wrap.find('.step.current-active').attr('data-step'),
        $current_slide = $('[data-step="'+current_slide_step+'"]');
    if(action == 'next') {
      if(!$current_slide.next().hasClass('preventEvents')) {
        
        var pointerEvents = $current_slide.next().css('pointerEvents');
        if(pointerEvents == 'none'){
          $current_slide.next().next().trigger('click');
        } else {
          $current_slide.next().trigger('click');
        }
      }
    } else {
      if(!$current_slide.prev().hasClass('preventEvents')) {
        var pointerEvents = $current_slide.prev().css('pointerEvents');
        if(pointerEvents == 'none') {
          $current_slide.prev().prev().trigger('click');
        } else {
          $current_slide.prev().trigger('click');
        }
      }
    }
  });

  $(document).on('click', '.confirm_my_account--js', function(){
    var $el = $(this),
        $main_wrap = $el.closest('.prescription_option .saved_prescriptions__array_wrap'),
        $select_prescription = $('.acc-content--js [name="saved_prescription_data"]:checked'),
        cus_mgs = `Please select your prescription!`;
    if($select_prescription.length) {
      stepGoTo(3);
    } else {
      alertPopup(cus_mgs);
      return;
    }
  });
  
  $(document).on('click', '.confirm-prescription-manually, .saved-prescriptions--action', function(){

    var $el = $(this),
        $main_wrap = $el.closest('.prescription_option'),
        main_od = {
          sph: $main_wrap.find('[name="od_sph"]').val(),
          cyl: $main_wrap.find('[name="od_cyl"]').val(),
          axis: $main_wrap.find('[name="od_axis"]').val(),
          add: $main_wrap.find('[name="od_add"]').val()
        },
        main_os = {
          sph: $main_wrap.find('[name="os_sph"]').val(),
          cyl: $main_wrap.find('[name="os_cyl"]').val(),
          axis: $main_wrap.find('[name="os_axis"]').val(),
          add: $main_wrap.find('[name="os_add"]').val()
        },
        single_pd = $('[name="pd"]').val(),
        $dual_pd_checkbox = $('#pd-checkbox').find('[name="is_pd"]'),
        dual_right_pd = $('[name="od_pd"]').val(),
        dual_left_pd = $('[name="os_pd"]').val(),
        manually_comment = $('[name="comment"]').val(),
        prism_od = {
          v_v: $main_wrap.find('[name="od_v_prism"]').val(),
          v_b: $main_wrap.find('[name="od_v_direction"]').val(),
          h_v: $main_wrap.find('[name="od_h_prism"]').val(),
          h_b: $main_wrap.find('[name="od_h_direction"]').val()
        },
        prism_os = {
          v_v: $main_wrap.find('[name="os_v_prism"]').val(),
          v_v: $main_wrap.find('[name="os_v_direction"]').val(),
          h_v: $main_wrap.find('[name="os_h_prism"]').val(),
          h_b: $main_wrap.find('[name="os_h_direction"]').val()
        };
        var usage_select = $('#usage-slide').attr('data-usage-value');
    
        if($(this).hasClass('saved-prescriptions--action')) {
       if(!window.customerLoggedIn) {
       $('body').removeClass('savePrescriptionEvent');
        var link = $('.product-genric--url').val(),
            cus_mgs = `You hove to logged in!<br>Please <a class="anchor_link" href="/account/login?return_url=${link}?view=customize">click here</a> and go to the login page`
        alertPopup(cus_mgs);
        return;
      }
    }
    
    $('#presc-slide').attr('data-prescription-method', $main_wrap.attr('data-option-title'));

    if(usage_select === '1' || usage_select == 1) {
      // console.log(main_od.sph , main_od.cyl, main_os.sph, main_os.cyl)
      if(main_od.sph === '0.00' && main_od.cyl === '0.00' && main_os.sph === '0.00' && main_os.cyl === '0.00') {
        if($('body').hasClass('goToNonPrescription')) {
          $('.goto-non-prescription').trigger('click');
        } else {}
        var no_prep_mgs = `You have not entered a prescription for your glasses. Would you like for us to process your order with Non-Prescription lenses?`;
        alertPopup(no_prep_mgs, true, `goToNonPrescription`, `Continue with non-prescription`);
        return false;
      }
    }

    if(!$('.know_pd:checked').length){
      var select_pd_mgs = `You have not select PD for your glasses. <b>Please select PD</b>, if you don't know your PD. <br>That's okay! We'll get in touch to help you get your PD later`;
      alertPopup(select_pd_mgs);
      return false;
    }

    var value_for_main_od = `Sphere(SPH): ${main_od.sph || 'n/a'}, Cylinder(CYL): ${main_od.cyl || 'n/a'}, Axis: ${main_od.axis || 'n/a'}, Add: ${main_od.add || 'n/a'}`;
    var value_for_main_os = `Sphere(SPH): ${main_os.sph || 'n/a'}, Cylinder(CYL): ${main_os.cyl || 'n/a'}, Axis: ${main_os.axis || 'n/a'}, Add: ${main_os.add || 'n/a'}`;
    var pd_value = '', is_prism = false, ihavemypd = '';
    if($('.know_pd:checked').length && $('.know_pd:checked').val() == 'Yes') {
      if(!$dual_pd_checkbox.prop('checked')) {
        pd_value = `Single Number: ${single_pd || 'n/a'}`;
      } else {
        pd_value = `Left Number: ${dual_left_pd || 'n/a'}, Right Number: ${dual_right_pd || 'n/a'}`;
      }
    }
    ihavemypd = '<input type="hidden" name="properties[I Have My PD]" value="'+$('.know_pd:checked').val()+'">';

    if($('[name="is_prism"]').prop('checked')) {
      is_prism = true;
      var prism_addon_id = $('[name="is_prism"]').attr('data-variant-id');
      var value_for_prism_od = `Verticle: ${prism_od.verticle || 'n/a'}, Base Direction(Verticle): ${prism_od.v_base_dir || 'n/a'}, Horizontal: ${prism_od.horizontal || 'n/a'}, Base Direction(Horizontal): ${prism_od.h_base_dir || 'n/a'}`;
      var value_for_prism_os = `Verticle: ${prism_os.verticle || 'n/a'}, Base Direction(Verticle): ${prism_os.v_base_dir || 'n/a'}, Horizontal: ${prism_os.horizontal || 'n/a'}, Base Direction(Horizontal): ${prism_os.h_base_dir || 'n/a'}`;
    }
    var two_pd_message = `<div style="padding:8px">Please select your pupillary distance (PD).<br><br><div>Pupillary distance or PD is the distance from the center of the pupil in one eye to the center of the pupil in the other eye.<br><br>If you do not have the PD, you can measure it as shown below:<br><img src="https://img.ebdcdn.com/image/upload/static/images/measure_eye_1.jpg?q=85"></div></div>`;
    var prism_required_mgs = `Please choose the prism value.`;
    var alert_message = '', usage_monogram = $('#usage_monogram').val();
    
    if(!$('body').hasClass('addSkip')) {
      if(usage_select == 3 || usage_select === '3') {
        if(main_os.add != '' || main_od.add != '') {}else {
          alert_message = `Please make sure to enter the Addition (ADD) value if it is listed in your prescription, otherwise proceed with the order.`
          alertPopup(alert_message, true, 'addSkip');
          return false;
        }
      }
    }

    if(main_od.cyl !== '0.00') {
      if(main_od.axis == '') {
        alertPopup(`You chose CYL value, please add the Axis value`);
        return false;
      }
    }

    if(usage_select == 2 || usage_select === '2') {
      if(main_os.add == '' || main_od.add == '') {
        alert_message = `You selected ${usage_monogram} as primary use of your glasses, please input your ADD for the reading portion of your glasses`
        alertPopup(alert_message);
        return false;
      }
    }
    
    if(main_os.cyl !== '0.00') {
      if(main_os.axis == '') {
        alertPopup(`You chose CYL value, please add the Axis value`);
        return false;
      }
    }
    
    if(is_prism) {
      var prism_any_req_mgs = '', prism_require = true;
      if(prism_od.v_v != '' || prism_od.v_b != ''){
        prism_require = false;
        if(prism_od.v_v == ''){
          prism_any_req_mgs = `Please choose the prism value.`;
        } else if(prism_od.v_b == ''){
          prism_any_req_mgs = `Please choose the base direction of your prism`
        }
      }
      if(prism_od.h_v != '' || prism_od.h_b != ''){
        prism_require = false;
        if(prism_od.v_v == ''){
          prism_any_req_mgs = `Please choose the prism value.`;
        } else if(prism_od.v_b == ''){
          prism_any_req_mgs = `Please choose the base direction of your prism`
        }
      }
      if(prism_os.v_v != '' || prism_os.v_b != ''){
        prism_require = false;
        if(prism_od.v_v == ''){
          prism_any_req_mgs = `Please choose the prism value.`;
        } else if(prism_od.v_b == ''){
          prism_any_req_mgs = `Please choose the base direction of your prism`
        }
      }
      if(prism_os.h_v != '' || prism_os.h_b != ''){
        prism_require = false;
        if(prism_od.v_v == ''){
          prism_any_req_mgs = `Please choose the prism value.`;
        } else if(prism_od.v_b == ''){
          prism_any_req_mgs = `Please choose the base direction of your prism`
        }
      }
      if(prism_require) {
        alertPopup(prism_required_mgs);
        return false;
      } else if(prism_any_req_mgs != ''){
        alertPopup(prism_any_req_mgs);
        return false;
      }
    }
    


    if($dual_pd_checkbox.prop('checked')) {
      if(dual_left_pd == '' || dual_right_pd == '') {
        alertPopup(two_pd_message);
        return false;
      }
    }
    
    var prism_inputs = '', near_pd_value = '';
    if($('#near-pd-checkbox-input').prop('checked') && $('[name="npd"]').val() != '') {
      var nepd_val = $('[name="npd"]').val();
      near_pd_value = `<input type="hidden" name="properties[Near PD Value]" value="${nepd_val  || 'n/a'}">`
    }
    if($('#prism').prop('checked')) {
      prism_inputs = `<input type="hidden" name="properties[Prism Right Eye Selection]" value="${value_for_prism_od}">
                      <input type="hidden" name="properties[Prism Left Eye Selection]" value="${value_for_prism_os}">
                      <input class="addon_id" type="hidden" value="${prism_addon_id}">
                      <input type="hidden" name="properties[Prism Comment]" value="${manually_comment}">`
    }
    var inputs = `<input type="hidden" name="properties[Right Eye Selection]" value="${value_for_main_od}">
                  <input type="hidden" name="properties[Left Eye Selection]" value="${value_for_main_os}">
                  <input type="hidden" name="properties[PD value]" value="${pd_value}">
                  ${prism_inputs} ${near_pd_value} ${ihavemypd}`;
    
    $('.entermanually_data__js').html(inputs);
    var usage_select = $('#usage-slide').attr('data-usage-value');
    if($el.hasClass('saved-prescriptions--action')) {
      $('body').addClass('savePrescriptionEvent');
      if(window.customerLoggedIn) {
        var $sp_preview = $('#saved_prescriptions_preview'), p_type = $('#usage_monogram').val();
        $sp_preview.find('.pw_od_sph').html(main_od.sph || 'n/a');
        $sp_preview.find('.pw_od_cyl').html(main_od.cyl || 'n/a');
        $sp_preview.find('.pw_od_axis').html(main_od.axis || 'n/a');
        $sp_preview.find('.pw_od_add').html(main_od.add || 'n/a');
        $sp_preview.find('.pw_od_pd').html();

        $sp_preview.find('.pw_os_sph').html(main_os.sph || 'n/a');
        $sp_preview.find('.pw_os_cyl').html(main_os.cyl || 'n/a');
        $sp_preview.find('.pw_os_axis').html(main_os.axis || 'n/a');
        $sp_preview.find('.pw_os_add').html(main_os.add || 'n/a');
        $sp_preview.find('.ptype_value').html(p_type);
        var data = {
          "SPH(Right Eye)": main_od.sph,
          "CYL(Right Eye)": main_od.cyl,
          "AXIS(Right Eye)": main_od.axis,
          "ADD(Right Eye)": main_od.add,
          "SPH(Left Eye)": main_os.sph,
          "CYL(Left Eye)": main_os.cyl,
          "AXIS(Left Eye)": main_os.axis,
          "ADD(Left Eye)": main_os.add,
          "Power Type": p_type
        };
        
        if($('[name="know_pd"]:checked').val() == 'No') {
            $sp_preview.find('.pw_od_pd').html("Don't know").attr('rowspan', '2');
            $sp_preview.find('.pw_os_pd').html('').hide();
          data['Single PD'] = "Don't know";
        } else {
          if($dual_pd_checkbox.prop('checked')) {
            $sp_preview.find('.pw_od_pd').html(dual_right_pd || 'n/a').attr('rowspan', '');
            $sp_preview.find('.pw_os_pd').html(dual_left_pd || 'n/a').show();
            data["PD(Left Eye)"] = dual_left_pd;
            data["PD(Right Eye)"] = dual_right_pd;
          } else {
            $sp_preview.find('.pw_od_pd').html(single_pd || 'n/a').attr('rowspan', '2');
            $sp_preview.find('.pw_os_pd').html('').hide();
            data['Single PD'] = single_pd;
          }
        }
        if($('#near-pd-checkbox-input').prop('checked') && $('[name="npd"]').val() != '') {
          var nepd_val = $('[name="npd"]').val();
          $sp_preview.find('.pw_tr-near-pd.npd').html(nepd_val);
          $sp_preview.find('.pw_tr-near-pd').show();
          data['Near PD'] = nepd_val;
        } else {
          $sp_preview.find('.pw_tr-near-pd').hide();
        }
        
        console.log(data);
        $('#saved_data').val(JSON.stringify(data));
        alertPopup($sp_preview.html(), true, 'save_prescription__js', 'Your prescription');
        $('body').addClass('table_content_wrap');
      } else {
         $('body').removeClass('savePrescriptionEvent');
        var link = $('.product-genric--url').val(),
            cus_mgs = `You hove to logged in!<br>Please <a class="anchor_link" href="/account/login?return_url=${link}?view=customize">click here</a> and go to the login page`
        alertPopup(cus_mgs);
      }
    } else {
      stepGoTo(3);
    }
  }); // confirm-prescription-manually

  $(document).on('change', '.color-swatch--input', function(){
    var $el = $(this),
      $main_wrap = $el.closest('.color-section'),
      $wrap = $el.closest('.swatch-cover'),
      strength = $wrap.attr('data-strength'),
      val = $el.val();
    console.log('strength>>', strength);
    if(strength) {
      console.log('has-strength');
      var strength_arr = strength.split(','), strength_html = '';
      for(var i = 0; i < strength_arr.length; i++){
        var checked = (i==0)?'checked':'';
        var strength_value = strength_arr[i].split(':'); 
        strength_html += `<div class="strength_cover">
        <input class="strength_input" id="strenth_value-${val}-${i}" value="${strength_arr[i]}" name="strenth_value<<>>${val}" type="radio" ${checked}>
        <label class="strength_label"  for="strenth_value-${val}-${i}">${strength_arr[i].replace(':', ' ')}</label>
        </div>`
      }
      strength_html = `<div class="strength_main_cover">${strength_html}</div>`;
      $main_wrap.find('.tint_strength--js .color-values').html(strength_html).show();
       $main_wrap.find('.tint_strength--js').show();
    } else {
      console.log('no-strength');
      $main_wrap.find('.tint_strength--js .color-values').html('').hide();
      $main_wrap.find('.tint_strength--js').hide();
    }
  });

  $(document).on('click', '.select_lenses--js', function(e){
    e.preventDefault();
    insertParam('view', 'customize');
  });

  // send later prescription
  $(document).on('click', '.sendlater--js', function(e){
    var $el = $(this),
        $wrap = $el.closest('.prescription_option');
    
    if($wrap.length) {
      var optionPrescriptionTitle = $wrap.attr('data-option-title');
      $('#presc-slide').attr('data-prescription-method', optionPrescriptionTitle);
    }
    if($(e.target).closest('.tooltip_icon__wrap').length || $(e.target).hasClass('tooltip_icon__wrap')){} else {
      $('#presc-slide .prescription_option').removeClass('prescription_active');
      $wrap.addClass('prescription_active');
      stepGoTo(3);
    }
  });

  // upload file prescription
  $(document).on('click', '.rx4-upload-comfirm-button', function(){
    var $el = $(this),
        additionalInformation = $('[name="additionalInformation"]').val(),
        file_val = $('#upload_file_input').val() || false,
        file_upload_alert = `Please Upload a File.`,
        $wrap = $el.closest('.prescription_option');
    
    $('#additionalInformation_hidden').val(additionalInformation);
    if(file_val) {
      
    } else {
      alertPopup(file_upload_alert);
      $('.upload-content-wrapper .drop-zone').css('border-color', '#f00');
      return false;
    }
    $('#presc-slide').attr('data-prescription-method', $wrap.attr('data-option-title'));
    stepGoTo(3);
  });

  $(document).on('change', '#od_add, #os_add', function(){
    var $od = $('#od_add'),
        $os = $('#os_add'),
        unusual_message = `That's unusual! For most people, Addition (ADD) values are the same for both eyes. Please confirm your prescription indicates separate values under ADD. For help, please contact customer support.`;
    if($od.val() != '' && $os.val() != ''){
      if($od.val() != $os.val()) {
        alertPopup(unusual_message);
      }
    }
    if($od.val() != '' || $os.val() != ''){
      $('.near-pd--checkbox').show();
    } else {
      $('.near-pd--checkbox').hide();
    }
    
  });
  $(document).on('change', '#near-pd-checkbox-input', function(){
    var $el = $(this);
    if($el.prop('checked')) {
      $('.js-near-pd').slideDown(function(){
        addapiveHeight();
      });
    } else {
      $('.js-near-pd').slideUp(function(){
        addapiveHeight();
      });
    }
  })
  

  $(document).on('click', '#popup-close', function(){
    alertPopup(false);
  });

  $(document).on('click', '.popup-button-submit', function(){
    alertPopup(false);
  });

  $(window).on('click', function(e){
    if(e.target.id === 'customize_modal--alert'){
      alertPopup(false);
    }
  });

  $(document).on('change', '[name="od_cyl"]', function(){
    var $el = $(this),
        val = $el.val(),
        $axis = $('[name="od_axis"]');
    if(val === '0.00') {
      $axis.prop('disabled', true).addClass('disabled').val('');
    } else {
      $axis.prop('disabled', false).removeClass('disabled');
    }
  });

  $(document).on('change', '[name="os_cyl"]', function(){
    var $el = $(this),
        val = $el.val(),
        $axis = $('[name="os_axis"]');
    if(val === '0.00') {
      $axis.prop('disabled', true).addClass('disabled').val('');
    } else {
      $axis.prop('disabled', false).removeClass('disabled');
    }
  });

  $(document).on('click', '#customize_modal--alert .continue_btn', function(){
    var $el = $(this),
        body_class = $el.attr('data-body_class');
    
    if(body_class == 'save_prescription__js') {
      savePrescription($el);
      return;
    }
    if(body_class == 'goToNonPrescription') {
      $('.goto-non-prescription').trigger('click');
      alertPopup(false);
      return false;
    }
    $('body').addClass(body_class);
    alertPopup(false);
    if(!$('body').hasClass('savePrescriptionEvent')) {
      $('.saved-prescriptions--action').trigger('click');
      return;
    }
    $('.confirm-prescription-manually').trigger('click');
  });


  $(document).on('click', '#ebd_lensesbundle .js-add-to-cart', function(){
    var ids_arr = [];
      var $el = $(this),
        $usage = $('#usage-slide'),
        $prescription = $('#presc-slide'),
        $color_type = $('#color-slide'),
        $lensebundle = $('#lensebundle-slide'),
        $ebd_lensesbundle = $('#ebd_lensesbundle'),
        savedPrescriptionData = null;

    $('#ebd_lensesbundle .js-add-to-cart, .trigger-js-add-to-cart').prop('disabled', true).addClass('loading');
    $('body').removeClass('product_customizer--prevent');
    // usage step
    var usage_monogram = $('#usage_monogram').val(),
        usage_addon_id = $('#usage_var_id').val();
    if(usage_addon_id != null && usage_addon_id != '') {
      ids_arr.push(usage_addon_id);
    }

    // prescription step
    var method = $prescription.attr('data-prescription-method');
    var methodTxt = '';
    if(method == 'sendLater') {
      methodTxt = 'Send Later';
    } else if(method == 'uplaodFile') {
      methodTxt = 'Upload a File';
    } else if(method == 'enterManually') {
      if($('[name="is_prism"]').prop('checked')) {
        var prism_var_id = $('[name="is_prism"]').attr('data-variant-id');
         if(prism_var_id != null && prism_var_id != '') {
          ids_arr.push(prism_var_id);
         }
      }
      var entermanually_data = $('.entermanually_data__js').html();
      $('[monograms_container]').append(entermanually_data);
      methodTxt = 'Enter Manually';
    } else if(method == 'myAccount') {
      methodTxt = 'From My Account';
      savedPrescriptionData = $('.acc-content--js [name="saved_prescription_data"]:checked').val();
      console.log('savedPrescriptionData>>>', savedPrescriptionData);
    }
    

    // color type step
    var color_type_monogram = $('#color_type_monogram').val(),
        color_type_inner = $('#color_type_monogram').attr('data-inner-value'),
        color_type_inner_2 = $('#color_type_monogram').attr('data-inner-2-value'),
        color_type_value_monogram = $('#color_type_value_monogram').val(),
        color_type_value_variant = $('#color_type_value_variant').val();
    if(color_type_value_variant != null && color_type_value_variant != '') {
      // ids_arr.push(color_type_value_variant);
    }

    // Bundle Step
    var lenses_bundle__monogram = $('#lenses_bundle__monogram').val(),
        lenses_bundle__var_id = $('#lenses_bundle__var_id').val();
    if(lenses_bundle__var_id != null && lenses_bundle__var_id != '') {
      ids_arr.push(lenses_bundle__var_id);
    }

    var additionalInformation = $('[name="additionalInformation"]').val();

    if($('#usage-slide').attr('data-usage-value') == 4 || $('#usage-slide').attr('data-usage-value') == '4'){
      methodTxt = '';
    }
    if(savedPrescriptionData != null) {
      console.log(savedPrescriptionData, '<<<savedPrescriptionData');
       var mono_saved = `<input type="hidden" name="properties[Saved Prescription]" value='${savedPrescriptionData.replaceAll("'", "")}'/>`;
    }
    
    const fields = [
        ["Usage Step", usage_monogram],
        ["Prescription Method", methodTxt],
        ["Color Type Selection", color_type_monogram],
        ["Color Type Inner", color_type_inner],
        ["Color Type Inner 2", color_type_inner_2],
        ["Color Type Selection Value", color_type_value_monogram],
        ["Bundle Selection", lenses_bundle__monogram],
        ["Additional Information", additionalInformation],
      ];

      let all_monogram_values = fields
        .filter(([, v]) => v)
        .map(([k, v]) => `<input type="hidden" name="properties[${k}]" value="${v}"/>`)
        .join("\n");

      if (mono_saved) all_monogram_values += `\n${mono_saved}`;

    $('[monograms_container]').append(all_monogram_values);

    addAllItems(ids_arr);
     
  });

  $(document).on('input', '#customize_modal--alert #sp_username', function(){
   var $el = $(this);
    $el.css('borderColor', '')
  });

  $(document).on('click', '.backtoproduct', function(){
   var url = $(this).attr('data-url');
    window.location.href = url;
  });

  var pds_content = `<div class="tips-prescription-content">
        <div class="rx-video-content-container js-rx-video-help" data-videourl="https://www.youtube.com/embed/b5dOglpKq4I?rel=0&amp;border=0&amp;autoplay=true">
             <strong>PD (Pupillary Distance)</strong>
            <p>It’s just what it sounds like — the distance in millimeters (mm) between your pupils. An average PD measurement in 63mm, but it varies by person. If your PD number isn’t on your prescription, you can measure it yourself by:            <br>
            • Printing the <a class="u primary" data-event-label="PD Ruler RX" target="_blank" href="/downloads/measure-your-pd-with-ruler.pdf">downloadable PD ruler</a>.`
  $(document).on('click', '.pd-description--js', function(){
    alertPopup(pds_content);
  });

  $(document).on('click', '.remove_customize_prod', function(e){
    e.preventDefault();
    let confirm_mgs = "All your entered information will be lost. Are you sure you want to leave this page?";
    if (!confirm(confirm_mgs)) { return false; }
    var $el = $(this),
        timespan = $el.attr('data-timespan'),
        cls = `.cls_${timespan}`,
        ids = [];
    $(cls).each(function(){
      var key = $(this).attr('data-key');
      ids.push(key);
    });
    removeItems(ids);
  });

  $(document).on('change', '.know_pd', function(){
    var $el = $(this),
        val = $el.val();
    if(val == 'Yes') {
      $('.know_pd[value="Yes"]').closest('.label_cls').find('.ikpd_desc').show();
      $('.know_pd[value="No"]').closest('.label_cls').find('.ikpd_desc').hide();
      $('.know_pd_content__js').slideDown(function(){
        addapiveHeight();
      });
    } else {
      $('.know_pd[value="Yes"]').closest('.label_cls').find('.ikpd_desc').hide();
      $('.know_pd[value="No"]').closest('.label_cls').find('.ikpd_desc').show();
      $('.know_pd_content__js').slideUp(function(){
        addapiveHeight();
      });
    }
  });

  $(document).on('click', '.trigger-js-add-to-cart', function(){
    $('.js-add-to-cart').trigger('click');
  });

}); //ready

stepGoTo = (step) => {
  step = parseInt(step);
  var step1 = step + 1,
      step0 = step - 1;
  console.log('step0>>', step0, 'step>>', step, 'step1>>', step1);
  if(step==5 || step == 4){
    $('.trigger-js-add-to-cart').show();
  } else {
    $('.trigger-js-add-to-cart').hide();
  }
  
  
  var cStep = $('body').attr('data-customize-step') || 'nullValue';
  if(cStep==='nullValue' || step > cStep){
    $('body').attr('data-customize-step', step);
  }
  var bigStep = $('body').attr('data-customize-step');
  $('.steps .step').removeClass('step-back-current');
 
  for(var i = 1; i < bigStep; i++) {
    $('.step[data-step="'+i+'"]').removeClass('current-active preventEvents').addClass('step-completed');
  }
  $('.step[data-step="'+bigStep+'"]').removeClass('step-completed preventEvents').addClass('current-active');
  if( $('.step[data-step="'+step+'"]').hasClass('step-completed')) {
    $('.step[data-step="'+step+'"]').addClass('step-back-current');
  }
  
  setTimeout(function(){
    $('.slides--wrap').slick('slickGoTo', step0);
    (step == 1)?$('[data-action="prev"]').css('visibility','hidden').addClass('backtoproduct').attr('title', 'Back to product page'):$('[data-action="prev"]').css('visibility','').removeClass('backtoproduct').attr('title', '');
    (step == 5 || step == 4)?$('[data-action="next"]').css('visibility','hidden'):$('[data-action="next"]').css('visibility','');
    if($(`.step[data-step="${step1}"]`).hasClass('preventEvents')){
      $('[data-action="next"]').addClass('disabled')
    } else {
      $('[data-action="next"]').removeClass('disabled');
    }
  },1);
}


function addapiveHeight(){
  setTimeout(function(){
    var height = $('.slide-item.slick-current').outerHeight();
    $('.slides--wrap .slick-list').height(height);
    // console.log('height>>>', height);
  },50);
}

function lense_bundle_filter() {
  var step_1_index = $('#usage-slide').attr('data-usage-value'),
      step_3_index = $('#color-slide').attr('data-color_type-value'),
      $step_content = $('#lensebundle-slide .step4_class'),
      sun = '#lensebundle-slide .step-4-sun--content',
      clear = '#lensebundle-slide .step-4-clear--content',
      blf = '#lensebundle-slide .step-4-blf--content', 
      lil = '#lensebundle-slide .step-4-lil--content';
  if(step_1_index != null && step_3_index != null) {
    $step_content.hide();

    var switch_val = step_1_index+'<<-->>'+step_3_index;
    switch(switch_val) {
      case '1<<-->>1':
      case '3<<-->>1':
        console.log('Usage >> Distance & Reading, Type >> Clear');
        $(`${clear}[data-usage-step="1"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${clear}[data-sun-step]`).hide();
          $(`${clear}[data-usage-step="1"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${clear} [data-inner-step]`).hide();
          $(`${clear}[data-usage-step="1"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '1<<-->>2':
      case '3<<-->>2':
        console.log('Usage >> Distance & Reading, Type >> BLF');
        $(`${blf}[data-usage-step="1"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${blf}[data-sun-step]`).hide();
          $(`${blf}[data-usage-step="1"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${blf} [data-inner-step]`).hide();
          $(`${blf}[data-usage-step="1"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '1<<-->>3':
      case '3<<-->>3':
        console.log('Usage >> Distance & Reading, Type >> Sun');
        $(`${sun}[data-usage-step="1"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${sun}[data-sun-step]`).hide();
          $(`${sun}[data-usage-step="1"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        console.log(inner2_step,'---inner2_step')
        if(inner2_step != null) {
          $(`${sun} [data-inner-step]`).hide();
          $(`${sun}[data-usage-step="1"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '1<<-->>4':
      case '3<<-->>4':
        console.log('Usage >> Distance & Reading, Type >> LIL');
        $(`${lil}[data-usage-step="1"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          console.log(inner_step)
          $(`${lil}[data-sun-step]`).hide();
          $(`${lil}[data-usage-step="1"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${lil} [data-inner-step]`).hide();
          $(`${lil}[data-usage-step="1"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '2<<-->>1':
        console.log('Usage >> Multifocal, Type >> Clear');
        $(`${clear}[data-usage-step="2"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${clear}[data-sun-step]`).hide();
          $(`${clear}[data-usage-step="2"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${clear} [data-inner-step]`).hide();
          $(`${clear}[data-usage-step="2"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '2<<-->>2':
        console.log('Usage >> Multifocal, Type >> BLF');
        $(`${blf}[data-usage-step="2"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${blf}[data-sun-step]`).hide();
          $(`${blf}[data-usage-step="2"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${blf} [data-inner-step]`).hide();
          $(`${blf}[data-usage-step="2"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '2<<-->>3':
        console.log('Usage >> Multifocal, Type >> Sun');
        $(`${sun}[data-usage-step="2"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${sun}[data-sun-step]`).hide();
          $(`${sun}[data-usage-step="2"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${sun} [data-inner-step]`).hide();
          $(`${sun}[data-usage-step="2"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '2<<-->>4':
        console.log('Usage >> Multifocal, Type >> LIL');
        $(`${lil}[data-usage-step="2"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${lil}[data-sun-step]`).hide();
          $(`${lil}[data-usage-step="2"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${lil} [data-inner-step]`).hide();
          $(`${lil}[data-usage-step="2"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '4<<-->>1':
        console.log('Usage >> Non-Prescription, Type >> Clear');
        $(`${clear}[data-usage-step="3"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${clear}[data-sun-step]`).hide();
          $(`${clear}[data-usage-step="3"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${clear} [data-inner-step]`).hide();
          $(`${clear}[data-usage-step="3"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '4<<-->>2':
        console.log('Usage >> Non-Prescription, Type >> BLF');
        $(`${blf}[data-usage-step="3"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${blf}[data-sun-step]`).hide();
          $(`${blf}[data-usage-step="3"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${blf} [data-inner-step]`).hide();
          $(`${blf}[data-usage-step="3"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '4<<-->>3':
        console.log('Usage >> Non-Prescription, Type >> Sun');
        $(`${sun}[data-usage-step="3"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${sun}[data-sun-step]`).hide();
          $(`${sun}[data-usage-step="3"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${sun} [data-inner-step]`).hide();
          $(`${sun}[data-usage-step="3"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
      case '4<<-->>4':
        console.log('Usage >> Non-Prescription, Type >> LIL');
        $(`${lil}[data-usage-step="3"]`).show();
        var inner_step = $('#color-slide').attr('data-inner-step');
        if(inner_step != null) {
          $(`${lil}[data-sun-step]`).hide();
          $(`${lil}[data-usage-step="3"][data-sun-step="${inner_step}"]`).show();
        }
        var inner2_step = $('#color-slide').attr('data-inner-2-step');
        if(inner2_step != null) {
          $(`${lil} [data-inner-step]`).hide();
          $(`${lil}[data-usage-step="3"][data-sun-step="${inner_step}"] [data-inner-step="${inner2_step}"]`).show();
        }
        break;
    }
    addapiveHeight();
  }
  if(step_1_index) {
    $(`#color-slide .color-section, #color-slide  .ploarized-wrap, #color-slide  .mirrored--wrap, #color-slide  .gradient--wrap, #color-slide .dl--wrap`).hide();
    switch(step_1_index) {
      case '1':
      case '3':
      case 1:
      case 3:
        $(`#color-slide .color-section[data-usage-id="1"], #color-slide .ploarized-wrap[data-usage-id="1"], #color-slide .mirrored--wrap[data-usage-id="1"], #color-slide .gradient--wrap[data-usage-id="1"], #color-slide .dl--wrap[data-usage-id="1"]`).show();
        break;
      case '2':
      case 2:
        $(`#color-slide .color-section[data-usage-id="2"], #color-slide .ploarized-wrap[data-usage-id="2"], #color-slide .mirrored--wrap[data-usage-id="2"], #color-slide .gradient--wrap[data-usage-id="2"], #color-slide .dl--wrap[data-usage-id="2"]`).show();
        break;
      case '4':
      case 4:
        $(`#color-slide .color-section[data-usage-id="3"], #color-slide .ploarized-wrap[data-usage-id="3"], #color-slide .mirrored--wrap[data-usage-id="3"], #color-slide .gradient--wrap[data-usage-id="3"], #color-slide .dl--wrap[data-usage-id="3"]`).show();
        break;
    }
  }
  
  // setTimeout(function(){
  //   var inner_step = $('#color-slide').attr('data-inner-step');
  //   console.log(inner_step, '<<inner_step')
  //   if(inner_step != null) {
  //     $('#lensebundle-slide [data-sun-step]').hide();
  //     $('#lensebundle-slide [data-usage-step="'+step_1_index+'"][data-sun-step="'+inner_step+'"]').show();
  //     console.log($('#lensebundle-slide [data-sun-step="'+inner_step+'"]').length);
  //   }

  //   var inner2_step = $('#color-slide').attr('data-inner-2-step');
  //   console.log(inner2_step, '<<inner2_step')
  //   if(inner2_step != null) {
  //     $('#lensebundle-slide [data-inner-step]').hide();
  //     $('#lensebundle-slide [data-usage-step="'+step_1_index+'"][data-sun-step="'+inner_step+'"] [data-inner-step="'+inner2_step+'"]').show();
  //      console.log($('#lensebundle-slide [data-inner-step="'+inner2_step+'"]').length);
  //   }
  // },1);
}



function insertParam(key, value, push = false) {
  key = encodeURIComponent(key);
  value = encodeURIComponent(value);

  // kvp looks like ['key1=value1', 'key2=value2', ...]
  var kvp = document.location.search.substr(1).split('&');
  let i=0;

  for(; i<kvp.length; i++){
      if (kvp[i].startsWith(key + '=')) {
          let pair = kvp[i].split('=');
          pair[1] = value;
          kvp[i] = pair.join('=');
          break;
      }
  }

  if(i >= kvp.length){
      kvp[kvp.length] = [key,value].join('=');
  }

  // can return this or...
  let params = kvp.join('&');

  if(push) {
    let u = `${window.location.origin + window.location.pathname}?${params}`;
    u = u.replace('?&', '?')
    window.history.replaceState({},"",u)
    return;
  }
  // reload page with new params
  document.location.search = params;
}

function addItem(form_id) {
 $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('#'+form_id).serialize(),
    success: function(cart){
      console.log(cart);
    },
    error: function(fail) {
      console.log(fail);
    }
 });
}


function alertPopup(message='', cancel=false, body_class='', title='') {
  if(message || message != ''){
    if(cancel == 'hide'){$('.popup-footer').hide()} else {$('.popup-footer').show()}
    if(cancel) {
      $('#customize_modal--alert .single_button').hide();
      $('#customize_modal--alert .double_btn').show();
      $('#customize_modal--alert .continue_btn').attr('data-body_class', body_class);
    } else {
      $('#customize_modal--alert .single_button').show();
      $('#customize_modal--alert .double_btn').hide();
      $('#customize_modal--alert .continue_btn').attr('data-body_class', '');
    }
    
    $('#customize_modal--alert [popup-message--container]').html(message);
    $('#customize_modal--alert').addClass('opened');
    $('body').addClass('modal-opened');
    if(title != '') {
      $('#customize_modal--alert .popup-title').html(title).removeClass('no-title')
    } else {
      $('#customize_modal--alert .popup-title').html('').addClass('no-title')
    }
  } else {
    $('#customize_modal--alert .popup-title').html('').removeClass('no-title')
    $('#customize_modal--alert [popup-message--container]').html('');
    $('#customize_modal--alert').removeClass('opened');
    $('body').removeClass('modal-opened'); 
    $('body').removeClass('table_content_wrap');
  }
}


function createSummary() {
  var $usage = $('#usage-slide'),
      $prescription = $('#presc-slide'),
      $color_type = $('#color-slide'),
      $lensebundle = $('#lensebundle-slide'),
      $ebd_lensesbundle = $('#ebd_lensesbundle'),
      usag_val = $usage.attr('data-usage-value');
    if(usag_val == 3){
      usag_val = 1;
    } else if(usag_val == 4) {
      usag_val = 3;
    }

  var $prescription_option = $prescription.find('.prescription_option'),
      main_od = {
        sph: $prescription_option.find('[name="od_sph"]').val(),
        cyl: $prescription_option.find('[name="od_cyl"]').val(),
        axis: $prescription_option.find('[name="od_axis"]').val(),
        add: $prescription_option.find('[name="od_add"]').val()
      },
      main_os = {
        sph: $prescription_option.find('[name="os_sph"]').val(),
        cyl: $prescription_option.find('[name="os_cyl"]').val(),
        axis: $prescription_option.find('[name="os_axis"]').val(),
        add: $prescription_option.find('[name="os_add"]').val()
      },
      single_pd = $('[name="pd"]').val(),
      $dual_pd_checkbox = $('#pd-checkbox').find('[name="is_pd"]'),
      dual_right_pd = $('[name="od_pd"]').val(),
      dual_left_pd = $('[name="os_pd"]').val(),
      manually_comment = $('[name="comment"]'),
      prism_od = {
        v_v: $prescription_option.find('[name="od_v_prism"]').val(),
        v_b: $prescription_option.find('[name="od_v_direction"]').val(),
        h_v: $prescription_option.find('[name="od_h_prism"]').val(),
        h_b: $prescription_option.find('[name="od_h_direction"]').val()
      },
      prism_os = {
        v_v: $prescription_option.find('[name="os_v_prism"]').val(),
        v_v: $prescription_option.find('[name="os_v_direction"]').val(),
        h_v: $prescription_option.find('[name="os_h_prism"]').val(),
        h_b: $prescription_option.find('[name="os_h_direction"]').val()
      };

    var usage_val = $usage.find('#usage_monogram').val(),
      upvl = $usage.find('#usage_var_id').attr('data-price'),
      upvl_id = $usage.find('#usage_var_id').val() || '',
      usage_price_vl = upvl,
      usage_price = (upvl == '' || upvl == null)? 'Free': Shopify.formatMoney(usage_price_vl, window.money_format);
  $ebd_lensesbundle.find('.usage-value--js').html(`<strong>${usage_val}</strong> <span class="rx-type-price price-symbol price-input" data-price="${upvl}" data-id="${upvl_id}">${usage_price}</span>`).show();
  $('.saved_prescription_tabel--js').html('').hide();
  if($usage.attr('data-usage-value') != 4 && $prescription.attr('data-prescription-method') == "enterManually") {
    $('.emt-js .od_sph').html(main_od.sph);
    $('.emt-js .od_cyl').html(main_od.cyl);
    $('.emt-js .od_axis').html(main_od.axis);
    $('.emt-js .od_add').html(main_od.add);

    $('.emt-js .os_sph').html(main_os.sph);
    $('.emt-js .os_cyl').html(main_os.cyl);
    $('.emt-js .os_axis').html(main_os.axis);
    $('.emt-js .os_add').html(main_os.add);

    
    if($dual_pd_checkbox.prop('checked')) {
      $('.emt-js .od_pd').html(dual_right_pd).attr('rowspan', '');
      $('.emt-js .os_pd').html(dual_left_pd).show();
    } else {
      $('.emt-js .od_pd').html(single_pd).attr('rowspan', '2');
      $('.emt-js .os_pd').html('').hide();
    }

    var near_pd_value = '';
    if($('#near-pd-checkbox-input').prop('checked') && $('[name="npd"]').val() != '') {
      var nepd_val = $('[name="npd"]').val();
      $('.emt-js .tr-near-pd.npd').html(nepd_val);
      $('.emt-js .tr-near-pd').show();
    } else {
      $('.emt-js .tr-near-pd').hide();
    }
    $('.enter_manually_table--js').show();
    $('.rx-review-prescription, .js--title').show();
  } else if($usage.attr('data-usage-value') != 4 && $prescription.attr('data-prescription-method') == "myAccount") {
    $('.rx-review-prescription, .js--title').show();
    $('.enter_manually_table--js').hide();
    var $saved_table = $('.acc-content--js [name="saved_prescription_data"]:checked').closest('.prescription_list_value').find('table')
    $('.saved_prescription_tabel--js').html($saved_table.html()).show();
  } else {
    $('.rx-review-prescription, .js--title').hide();
  }
  
  if($('#prism').prop('checked')) {
    var ppvl_p = $('#prism').attr('data-variant-price'),
        ppvl_id = $('#prism').val(),
        prism_price_vl = $('#prism').attr('data-variant-price') || 'Free' ,
        prism_price = (prism_price_vl == 'Free')? 'Free': Shopify.formatMoney(prism_price_vl, window.money_format);
    $ebd_lensesbundle.find('.prescription-prism-value--js').html(`<strong>Your Prescription &amp; Prism</strong> <span class="rx-type-price price-symbol price-input" data-price="${ppvl_p}" data-id="${ppvl_id}">${prism_price}</span>`).show();
    $('.od_prismnum_v').html(prism_od.v_v || 'n/a');
    $('.od_prismdir_v').html(prism_od.v_b || 'n/a');
    $('.od_prismnum_h').html(prism_od.h_v || 'n/a');
    $('.od_prismdir_h').html(prism_od.h_b || 'n/a');
    
    $('.os_prismnum_v').html(prism_os.v_v || 'n/a');
    $('.os_prismdir_v').html(prism_os.v_b || 'n/a');
    $('.os_prismnum_h').html(prism_os.h_v || 'n/a');
    $('.os_prismdir_h').html(prism_os.h_b || 'n/a');
    $('.prism_table').show();
  } else {
    $ebd_lensesbundle.find('.prescription-prism-value--js').html(``).hide();
    $('.prism_table').hide();
  }

  var clr_value = '';
  var color_type_stage = $color_type.attr('data-color_type-value')
  switch($color_type.attr('data-color_type-value')) {
    case '1':
    case 1:
      clr_value = 'Clear Lenses';
      break;
    case '2':
    case 2:
      clr_value = 'Blue Light Filtering';
      break;
    case '3':
    case 3:
      clr_value = 'Sunglasses';
      break;
    case '4':
    case 4:
      clr_value = 'Darkening Lenses';
      break;
  }
  var color_type_value = `<strong>${clr_value}</strong><span class="rx-type-price price-symbol">&nbsp;</span>`
  $ebd_lensesbundle.find('.color-type-value--js').html(color_type_value).show();

  console.log(color_type_stage,'<<color_type_stage')
  if(color_type_stage == 3 || color_type_stage == 4) {
    var ctvmmm = $('#color_type_value_monogram').val();
    var color_type_value_monogram = (ctvmmm == '')?ctvmmm:'('+ctvmmm+')';
    var ctvvp_p = $('#color_type_value_variant').attr('data-price');
    var ctvvp_id = $('#color_type_value_variant').val();
    var color_type_value_variant_price = ctvvp_p || 'Free';
    var ctvvp = (color_type_value_variant_price == 'Free')? 'Free': Shopify.formatMoney(color_type_value_variant_price, window.money_format);
    var inner_value = $('#color_type_monogram').attr('data-inner-value');
    var color_type_value_html = `<strong>${inner_value} ${color_type_value_monogram}</strong><span class="rx-type-price price-symbol price-input" data-price="${ctvvp_p}" data-id="${ctvvp_id}"><strong>Included</strong></span>`
    $('.colortype-color-value--js').html(color_type_value_html).show();
  } else {
    $('.colortype-color-value--js').html('').hide()
  }

  var bpvl_p = $('#lenses_bundle__var_id').attr('data-price'),
      bpvl_id = $('#lenses_bundle__var_id').val(),
      bundle_price_vl = bpvl_p || 'Free' ,
      bundle_price = (prism_price_vl == 'Free')? 'Free': Shopify.formatMoney(bundle_price_vl, window.money_format);
  var bundle_title = $('#lenses_bundle__monogram').val();
  var lenses_bundle_value = `<strong>${bundle_title}</strong><span class="rx-type-price price-symbol price-input" data-price="${bpvl_p}" data-id="${bpvl_id}">${bundle_price}</span>`;
  $ebd_lensesbundle.find('.lenses-bundle-value--js').html(lenses_bundle_value).show();

  var total_price = 0;
  $('#ebd_lensesbundle .price-input').each(function(){
    var $el = $(this),
      pp = ($el.attr('data-price') == 'undefined' || $el.attr('data-price') == 'Free')?0:$el.attr('data-price'),
      price = parseInt(pp);
     console.log('price> ', price)
    if(isNaN(price)){} else {
      total_price = total_price + price;
    }
  });
  console.log('total_price> ', total_price)
  $('#ebd_lensesbundle .js-subtotal-price, .js-subtotal-price, .js--subtotal').html(Shopify.formatMoney(total_price, window.money_format));

  var data_usage_value = $usage.attr('data-usage-value');
  if(data_usage_value == 1 || data_usage_value == 3) {
    $('.usage_1').show();
    $('.usage_2').hide();
    $('.usage_3').hide();
  } else if(data_usage_value == 2) {
    $('.usage_1').hide();
    $('.usage_2').show();
    $('.usage_3').hide();
  } else if(data_usage_value == 4) {
    $('.usage_1').hide();
    $('.usage_2').hide();
    $('.usage_3').show();
  }

  $('.lense_clr_type_li').each(function(index) {
    var $el = $(this),
        $content = $el.find('.jss-content-up');
    console.log(index, '>>', $content.length, '<<<<<<jjsccup');
    if($content.length == 1) {
     var $vContent = $content.find(`.color-section[data-usage-id="${usag_val}"]`);
      console.log($vContent.length, '<<<<<<inhdfhdfhddhdghd>>>>>>', $vContent.hasClass('has_only_default_variant'), index);
      if($vContent.length == 1 && $vContent.hasClass('has_only_default_variant')) {
        $el.addClass('has_main_default');
      }
    }
  });
  
}


function addAllItems(ids){
  var items = [],
      timeSpan = new Date().getTime();
  for(var i = 0; i < ids.length; i++) {
    var obj = {
      'id':ids[i],
      'quantity':1,
      'properties': {
        '__customize_addon': timeSpan
      }
    }
    items.push(obj);
  }

  let formData = {
    'items': items
  };

  $('#main_customize_product').val(timeSpan);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    $('#customize__file_upload').submit();
    return response.json();
  })
  .catch((error) => {
    $('body').addClass('product_customizer--prevent');
     $('#ebd_lensesbundle .js-add-to-cart, .trigger-js-add-to-cart').prop('disabled', false).removeClass('loading');
    console.error('Error:', error);
  });
}


const removeItems = (productIDS) => {
  console.log(productIDS)
  let formData = {
    'updates': {}
  };
  var productID;
  for (productID in productIDS) {
    formData['updates'][parseInt(productIDS[productID])] = 0;
  }
  let info = fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => response.json()).then(data => {
    window.location.reload();
    console.log(data);
  }).catch((error) => {
    console.error('Error:', error);
  });
}

const beforeUnloadListener = event => {
  if($('body').hasClass('product_customizer--prevent')) {
    event.preventDefault();
    return (event.returnValue = true);
  }
};

// $(".virtooal-tryon-btn-product-page").text('Try On!');
// $(".prescription_option[data-option-title='myAccount']").hide();

function myfun() {
  if($('body').hasClass('product_customizer--prevent')) {
    // set a truthy value to property returnValue
    event.returnValue = true;
  }
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function savePrescription($btn) {
  if($btn.hasClass('loading')) {return;}
 var prescriptions = JSON.parse($('#saved_data').val()),
     d = new Date(),
     key = d.getTime(),
     $name = $('#customize_modal--alert #sp_username');
  if(!$name.val().length){$name.css('borderColor', '#f00').focus();return;}
  prescriptions['User Name'] = $name.val();
  prescriptions = JSON.stringify(prescriptions);
  // prescriptions = prescriptions.replaceAll('"', '\\"')
  var sendDate = {"data":prescriptions,"key": key, "customerId": window.customerId, country: "uganda"};
  console.log("data:--",sendDate);
  $btn.addClass('loading');
  fetch('https://save-prescriptions-c47b28204811.herokuapp.com/api/save-prescription', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(sendDate)
  })
  .then(response => {
    return response.text();
  })
  .then(result => {
    console.log(result);
    $btn.removeClass('loading');
    alertPopup(false);
    stepGoTo(3);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
$(window).scroll(function(){if($(this).scrollTop() > 100){$('.announcement-bar').addClass('sticky');}else{$('.announcement-bar').removeClass('sticky');}});
$(document).on('click','.mobile-nav--button', function() {
    console.log('clickedddd>>>');
    $(this).closest('.mobile-nav--has-dropdown').find('.mobile-nav--dropdown').toggle();
});


  document.addEventListener("DOMContentLoaded", function () {
    const currentUrl = window.location.href;
    console.log("Current URL: " + currentUrl);

    const links = document.querySelectorAll(".mt_swatch a");

    links.forEach((link) => {
      const linkUrl = new URL(link.getAttribute("href"), window.location.origin).href;
      console.log("Checking Link URL: " + linkUrl);

      if (currentUrl.includes(linkUrl)) {
        const swatchImage = link.querySelector(".mt_swatch img");
        if (swatchImage) {
          swatchImage.style.border = "2px solid #000";
        }
      }
    });
  });